import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {PlaceholderChildComponent} from '@ispm/layout/classes/placeholder-child-component.abstract';
import {MenuItem} from 'primeng/api';
import {modalResponse} from '@ispm/layout/constants/modal-responses.enum';
import {get} from 'lodash';

@Component({
  selector: 'ispm-curation-pathway-tree-viewer',
  templateUrl: './curation-pathway-tree-viewer.component.html',
  styleUrls: ['./curation-pathway-tree-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationPathwayTreeViewerComponent extends PlaceholderChildComponent<any> implements OnInit {

  public data: any = [];
  public contextMenu: MenuItem[] = [];
  public isExpanded: boolean = false;
  public nodeStateMap: Map<string, boolean> = new Map<string, boolean>();

  constructor() {
    super();
  }

  ngOnInit() {
    this.data = !!this.payload.data ? this.payload.data : [];
    this.contextMenu = !!this.payload.config.contextMenu ? this.payload.config.contextMenu : undefined;
    this.isExpanded = get(this.data, 'showExpanded', false);
    this.nodeStateMap = get(this.data, 'nodesStateMap', undefined);
  }

  beforeClose(_modalResponse: modalResponse) {
  }

  onNodeEvent($event: any) {
    this.callback($event);
  }

}
